import React, { Component } from 'react';
import { connect } from 'react-redux';
import { withRouter } from 'react-router';
import axios from 'axios'
import { ROOT_API_URL } from "../../../../../api-config";
import { auth } from '../../../../../services/auth.service';
import StoreProduct from './StoreProduct';




class StoreHome extends Component {
    constructor(props) {
        super(props);

        this.state = {
            storeProducts: null
        }
    }

    componentDidMount() {
        window.location.href = "https://cattle-raisers-trading-co.myshopify.com/";

        //this.getProducts();
    }
    
    componentDidUpdate(prevProps) {
        if (this.props.location.search !== prevProps.location.search) {
            this.getProducts();
        }
    }

    getProducts = () => {
        this.setState({
            storeProducts: []
        })
        const categoryName = this.props.location.pathname.replace("/store/", "");
        const params = new URL(window.location.href).searchParams;
        const categoryId = params.get('categoryId');
        if (categoryId) {
            axios.get(`${ROOT_API_URL}/Product/GetProductByType?ProductTypeId=${categoryId}`, { headers: auth.authHeader() })
                .then(res => {
                    this.setState({
                        storeProducts: res.data,
                        categoryName: categoryName
                    })
                });
        } else {
            axios.get(`${ROOT_API_URL}/Product/GetAllProducts`, { headers: auth.authHeader() })
                .then(res => {
                    let products = res.data.filter(function (product) {
                        return product.isPublished == true
                    });
                    this.setState({
                        storeProducts: products,
                        categoryName: "Featured Collection"
                    })
                });
        }
    }

    displayProduct = (product, index) => {

        if (product.isMemberOnly && product.isPublished && (this.props.authentication.user?(this.props.authentication.user.membershipId !== 0 && this.props.authentication.user.membershipId !== undefined):"")) {
            return (
                <div className="product" key={index}>
                    <StoreProduct product={product} />
                </div>
            )
        } else if (!product.isMemberOnly && product.isPublished) {
            return (
                <div className="product" key={index}>
                    <StoreProduct product={product} />
                </div>
            )
        }
    }

    render() {
        return (
            <div className="storeProducts">
                <div className="container">
                    <h1 className="productListTitle">{this.state.categoryName ? this.state.categoryName : null}</h1>
                    <div className="productList row">
                        {this.state.storeProducts ? this.state.storeProducts.map((product, index) => {
                            return this.displayProduct(product, index)
                        }) : ""}
                     </div>
                </div>
            </div>
        );
    }
}

function mapStateToProps(state) {
    return {
        authentication: state.authentication,
        store: state.store
    }
}

export default withRouter(connect(mapStateToProps, {  })(StoreHome));